import 'css-chunksrc/client/pages/projectPage/synthesisPage/pdfExport/form/reportSelection/styles.scss';export default {
  "projectReportSelect": "_projectReportSelect_zmtse_1",
  "input": "_input_zmtse_5",
  "toggleIcon": "_toggleIcon_zmtse_21",
  "list": "_list_zmtse_27",
  "projectReport": "_projectReport_zmtse_1",
  "open": "_open_zmtse_53",
  "selectedReport": "_selectedReport_zmtse_59"
};